import { FEATURE_FLAGS } from '~/modules/experiments/features';
import { useFeatureFlags } from '~/modules/experiments/hooks/useFeatureFlags';
import {
  DEFAULT_PAGE_SIZE,
  DEFAULT_PAGE_SIZE_NO_PSSF,
} from '~settings/constants';

export function usePageSize(perPage?: number) {
  const [isPaginationEnabled] = useFeatureFlags([
    FEATURE_FLAGS.ContainerSettingsPssf,
  ]);

  return (
    perPage ??
    (isPaginationEnabled ? DEFAULT_PAGE_SIZE : DEFAULT_PAGE_SIZE_NO_PSSF)
  );
}
